import { FormControl, OutlinedInput, InputAdornment } from '@mui/material';
import { SearchIcon } from './icons';
import { ChangeEventHandler } from 'react';

export const SearchInput = ({
    onHandleChange
}: {
    onHandleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}) => {
    return (
        <FormControl
            sx={{
                background: 'white',
                borderRadius: '8px',
                height: '40px'
            }}
            variant='outlined'
            className='w-full flex-1 lg:flex-none lg:w-[35ch]'
        >
            <OutlinedInput
                startAdornment={
                    <InputAdornment position='start'>
                        <SearchIcon />
                    </InputAdornment>
                }
                sx={{
                    borderRadius: '8px',
                    height: '40px'
                }}
                placeholder='Search'
                onChange={onHandleChange}
            />
        </FormControl>
    );
};
